exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss"), undefined);

// module
exports.push([module.id, ".Edit__pagePadding___qPX9C {\n\tpadding-left: " + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["pagePadding"] + ";\n\tpadding-right: " + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["pagePadding"] + ";\n}\n\n.Edit__oneColumn___1tTUZ {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.Edit__bottomBorder___3reAb {\n\tborder-bottom: solid 1px #ccc;\n}\n\n.Edit__statistic___1PxX0 {\n\tdisplay: flex;\n\talign-items: baseline;\n}\n\n.Edit__statisticValue___1aKOq {\n\tflex: 1\n}\n\n.Edit__img___3o3gf {\n\theight: 80vw;\n\tmax-height: 30rem;\n}\n", ""]);

// exports
exports.locals = {
	"pagePadding": "Edit__pagePadding___qPX9C",
	"mainTextColour": "" + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["mainTextColour"] + "",
	"inverseMainTextColour": "" + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["inverseMainTextColour"] + "",
	"oneColumn": "Edit__oneColumn___1tTUZ",
	"bottomBorder": "Edit__bottomBorder___3reAb",
	"statistic": "Edit__statistic___1PxX0",
	"statisticValue": "Edit__statisticValue___1aKOq",
	"img": "Edit__img___3o3gf"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/Edit.icss
// module id = 1526
// module chunks = 0